var map = {
	"./Aatrox.png": 47,
	"./Amumu.png": 48,
	"./Annie.png": 49,
	"./Ashe.png": 50,
	"./Azir.png": 51,
	"./Brand.png": 52,
	"./Braum.png": 53,
	"./Diana.png": 54,
	"./DrMundo.png": 55,
	"./Ivern.png": 56,
	"./Janna.png": 57,
	"./Jax.png": 58,
	"./Karma.png": 59,
	"./Khazix.png": 60,
	"./Kindred.png": 61,
	"./KogMaw.png": 62,
	"./LeBlanc.png": 63,
	"./Leona.png": 64,
	"./Lucian.png": 65,
	"./Malphite.png": 66,
	"./Malzahar.png": 67,
	"./Maokai.png": 68,
	"./MasterYi.png": 69,
	"./Nami.png": 70,
	"./Nasus.png": 71,
	"./Nautilus.png": 72,
	"./Neeko.png": 73,
	"./Nocturne.png": 74,
	"./Olaf.png": 75,
	"./Ornn.png": 76,
	"./RekSai.png": 77,
	"./Renekton.png": 78,
	"./Senna.png": 79,
	"./Singed.png": 80,
	"./Sion.png": 81,
	"./Sivir.png": 82,
	"./Skarner.png": 83,
	"./Soraka.png": 84,
	"./Syndra.png": 85,
	"./Taliyah.png": 86,
	"./Taric.png": 87,
	"./Thresh.png": 88,
	"./Twitch.png": 89,
	"./Varus.png": 90,
	"./Vayne.png": 91,
	"./Veigar.png": 92,
	"./Vladimir.png": 93,
	"./Volibear.png": 94,
	"./Warwick.png": 95,
	"./Yasuo.png": 96,
	"./Yorick.png": 97,
	"./Zed.png": 98,
	"./Zyra.png": 99
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46;